import { handleResponse, makePost } from '@/redux/api/helpers';
import { PostFetchCatalogsByIdsPayload } from '@/redux/modules/catalog/catalog.types';

type FetchCatalogsByIdsParams = {
    authToken?: string;
    catalogIds: number[];
    deployment: string;
    forceNoCache?: boolean;
};

type PostFetchCatalogsByIdsResponse = {
    data: PostFetchCatalogsByIdsPayload;
    message: string;
    success: boolean;
};

export const postFetchCatalogsByIds = ({ authToken, catalogIds, deployment, forceNoCache }: FetchCatalogsByIdsParams) =>
    new Promise<PostFetchCatalogsByIdsResponse>((resolve, reject) => {
        const request = makePost({
            authToken,
            deployment,
            path: '<ITEM-API>spa/small/catalogs',
        });
        if (forceNoCache) {
            request.query({ forceNoCache });
        }
        request.send({ ids: catalogIds });
        request.end((err, response) => handleResponse({ err, reject, resolve, response }));
    });
